import { rootStateBranchSelector } from '../utils/rootStateBranchSelector';

export const similarOffersSelector = rootStateBranchSelector('similarOffers');
